(function () {
  Flint.file('mframework/views/slider.js', function (require) {
    /*
      Wrapper for jQuery UI Slider
    */

    Flint.staticStyles('Slider', {
      '$': '#_flintapp .ViewSlider',
      '$slider': '#_flintapp slider.Slider, #_flintapp .Slider.slider, #_flintapp .ViewSlider.slider, #_flintapp .Slider > .slider',
      '$notch': '#_flintapp notch.Slider, #_flintapp .Slider.notch, #_flintapp .ViewSlider.notch, #_flintapp .Slider > .notch',
      '$valueLabelContainer': '#_flintapp valueLabelContainer.Slider, #_flintapp .Slider.valueLabelContainer, #_flintapp .ViewSlider.valueLabelContainer, #_flintapp .Slider > .valueLabelContainer'
    }, {
      '$': {
        position: 'relative'
      },
      '$slider': {
        zIndex: 2,
        borderStyle: 'solid',
        borderWidth: 1,
        borderTopColor: '#ddd',
        borderLeftColor: '#ddd',
        borderBottomColor: '#aaa',
        borderRightColor: '#aaa'
      },
      '$notch': {
        position: 'absolute',

        width: 2,
        borderLeft: '1px solid rgba(50, 50, 50, 0.5)', //#6e7a8d',
        borderRight: '1px solid rgba(200, 200, 200, 0.5)',
        zIndex: 2
      },
      '$valueLabelContainer': {
        flexDirection: 'row',
        position: 'absolute',
        width: 0,

        fontSize: 13,
        whiteSpace: 'nowrap'
      }
    });
    Flint.view('Slider', function (view, on, $) {
      var context = initContext(view, {
        colors: atom()
      });

      var pro = initPro(view, {
        value: atom(),
        values: M.listAtom(),

        width: M.defaultAtom(400),
        min: M.defaultAtom(0),
        max: M.defaultAtom(100),
        handleWidth: M.defaultAtom(14),
        handleHeight: M.defaultAtom(14),
        labelContent: atom(),
        labelHeight: M.defaultAtom(26),
        notchInterval: M.defaultAtom(1),
        centerLabel: M.defaultAtom(true),
        barHeight: M.defaultAtom(8),
        range: M.defaultAtom(false), // true, false, 'min', 'max'
        rangeStyle: M.mapAtom({}),
        handleStyle: M.mapAtom({}),
        barStyle: M.mapAtom({})
      });

      var numNotches = derivation(function () {
        if (pro.notchInterval.get()) {
          return Math.max(0, Math.floor((pro.max.get() - pro.min.get()) / pro.notchInterval.get() - 1));
        } else {
          return 0;
        }
      });

      var barWidth = derivation(function () {
        return pro.width.get() - pro.handleWidth.get();
      });

      var values = M.listAtom(pro.values.get() || List([pro.value.get() || 0]));

      var hovering = atom(false);
      hovering.reactor(function (hovering) {
        if (view.props.onHover) view.props.onHover({ hovering: hovering });
      }).start();

      var rangeStyle = derivation(function () {
        return IMap({
          height: pro.barHeight.get(),
          background: 'rgba(221, 19, 123, 0.75)',
          borderRadius: 1,
          zIndex: 2
        }).merge(pro.rangeStyle.get());
      });

      var handleStyle = derivation(function () {
        return IMap({
          background: 'black',
          borderRadius: '50%',
          cursor: 'pointer',
          height: pro.handleHeight.get(),
          width: pro.handleWidth.get(),
          border: 'none',
          top: pro.barHeight.get() / 2 - pro.handleHeight.get() / 2,
          marginLeft: -pro.handleWidth.get() / 2 + 2,
          zIndex: 2
        }).merge(hovering.get() ? {
          background: 'black'
        } : null).merge(pro.handleStyle.get());
      });

      var barStyle = derivation(function () {
        return IMap({
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #ceced9 100%)',
          cursor: 'pointer',
          borderRadius: 2
        }).merge(pro.barStyle.get());
      });

      var slider = atom();
      slider.react(function (slider) {
        if (slider) {
          jQuery(slider).slider({
            range: pro.range.get(),
            min: pro.min.get(),
            max: pro.max.get(),
            value: pro.value.get(),
            values: pro.value.get() == null ? values.get().toJS() : null,
            slide: function slide(event, ui) {
              if (view.props.onSlide) {
                var ret = view.props.onSlide({
                  value: ui.value,
                  values: ui.values
                });
                if (ret === false) {
                  event.preventDefault();
                  return;
                }
              }
              values.set(List(ui.values || [ui.value]));
            }
          });

          styleJQuery();
        }
      });

      pro.value.react(function (propValue) {
        jQuery(slider.get()).slider({ value: propValue });
      }, { when: function when() {
          return pro.value.get() != null && slider.get();
        } });

      var styleJQuery = function styleJQuery() {
        if (!slider.get()) return;

        jQuery(slider.get()).css(barStyle.get().toJS());
        jQuery(slider.get()).find('.ui-slider-range').css(rangeStyle.get().toJS());
        jQuery(slider.get()).find('.ui-slider-handle').attr({
          /* The tabIndex is a jQuery UI accessibility feature
             but it makes an awkward rectangle around the focused
             slider control. */
          tabIndex: null
        }).css(handleStyle.get().toJS());
      };

      derivation(function () {
        return List([barStyle.get(), rangeStyle.get(), handleStyle.get()]);
      }).reactor(styleJQuery).start();

      var getLabelContent = function getLabelContent(value) {
        if (pro.labelContent.get() instanceof Function) {
          return pro.labelContent.get()(value);
        } else if (pro.labelContent.get() === true) {
          return '' + value;
        } else if (pro.labelContent.get()) {
          return pro.labelContent.get();
        } else {
          return null;
        }
      };view.render(function () {
        return view.el(
          ['slider', 1],
          { ref: function (elem) {
              return slider.set(elem);
            },
            onClick: view.props.onClick,
            onMouseDown: view.props.onMouseDown,
            onMouseUp: view.props.onMouseUp,
            onMouseEnter: function () {
              return hovering.set(true);
            },
            onMouseLeave: function () {
              return hovering.set(false);
            }
          },
          Flint.range(numNotches.get()).map(function (_, _index) {
            return view.el(['notch', 1, _, _index], { repeat: numNotches.get() });
          })
        );
      });view.render(function () {
        return Flint.iff(pro.labelContent.get()) && Flint.range(values.get()).map(function (_, _index) {
          return view.el(
            ['valueLabelContainer', 1, _, _index],
            { if: pro.labelContent.get(), repeat: values.get() },
            getLabelContent(_)
          );
        });
      });

      $["$"] = function (_, _index) {
        return {
          paddingTop: Math.max(0, (pro.handleHeight.get() - pro.barHeight.get()) / 2) - 2 + (pro.labelContent.get() ? pro.labelHeight.get() : 0),
          paddingBottom: Math.max(0, (pro.handleHeight.get() - pro.barHeight.get()) / 2) - 2,
          paddingLeft: pro.handleWidth.get() / 2,
          paddingRight: pro.handleWidth.get() / 2 };
      };

      $["slider"] = function (_, _index) {
        return {
          width: pro.width.get() - pro.handleWidth.get(),
          height: pro.barHeight.get() + 2 };
      };

      $["notch"] = function (_, _index) {
        return { height: pro.barHeight.get(), left: barWidth.get() * (_index + 1) / (numNotches.get() + 1)
        };
      };

      $["valueLabelContainer"] = function (_, _index) {
        return { justifyContent: pro.centerLabel.get() ? 'center' : null,
          marginTop: -pro.handleHeight.get() / 2 - pro.labelHeight.get(),
          left: 4 + (pro.centerLabel.get() ? pro.handleWidth.get() / 2 + (pro.width.get() - pro.handleWidth.get()) * (values.get().get(_index) - pro.min.get()) / (pro.max.get() - pro.min.get()) : (pro.width.get() - pro.handleWidth.get()) * (values.get().get(_index) - pro.min.get()) / (pro.max.get() - pro.min.get())) };
      };
    });
  })
})();
//# sourceMappingURL=slider.js.map
